/**
 * Stub pour class-validator - non utilisé dans le frontend
 * Ce fichier existe uniquement pour éviter les erreurs de résolution dans Vite
 */

// Les décorateurs sont supprimés à la compilation TypeScript de toute façon
// Mais ils doivent correspondre à la signature PropertyDecorator : (target, key) => void
// Et les décorateurs de class-validator sont des FACTORIES : () => PropertyDecorator

const StubDecorator =
  (...args: any[]) =>
  (target: any, key: any) => {};

export const IsEmail = StubDecorator;
export const IsString = StubDecorator;
export const IsNotEmpty = StubDecorator;
export const MinLength = StubDecorator;
export const IsOptional = StubDecorator;
export const IsBoolean = StubDecorator;
export const IsObject = StubDecorator;
export const IsArray = StubDecorator;
export const IsNumber = StubDecorator;
export const IsNotEmptyObject = StubDecorator;
export const MaxLength = StubDecorator;
export const IsUUID = StubDecorator;
export const IsEnum = StubDecorator;
export const ValidateNested = StubDecorator;
export const IsDate = StubDecorator;
export const IsInt = StubDecorator;
export const Min = StubDecorator;
export const Max = StubDecorator;
export const IsUrl = StubDecorator;
export const Matches = StubDecorator;
export const IsMongoId = StubDecorator;
export const IsAlphanumeric = StubDecorator;
export const IsAlpha = StubDecorator;
export const IsDateString = StubDecorator;
export const IsPhoneNumber = StubDecorator;
export const ArrayMaxSize = StubDecorator;
export const ArrayMinSize = StubDecorator;
export const IsDefined = StubDecorator;
export const IsIn = StubDecorator;
export const ArrayNotEmpty = StubDecorator;
export const Length = StubDecorator;
export const ValidateIf = StubDecorator;
export const IsHexColor = StubDecorator;
export const Validate = StubDecorator;

// ValidatorConstraint decorator (used for custom validators)
export const ValidatorConstraint =
  (options?: { name?: string; async?: boolean }) => (target: any) =>
    target;

// ValidatorConstraintInterface interface (for custom validators)
export interface ValidatorConstraintInterface {
  validate(value: any, validationArguments?: any): boolean | Promise<boolean>;
  defaultMessage?(validationArguments?: any): string;
}

// ValidationOptions and ValidationArguments types (used in custom validators)
export interface ValidationOptions {
  message?: string | ((validationArguments?: ValidationArguments) => string);
  groups?: string[];
  always?: boolean;
  each?: boolean;
  context?: any;
}

export interface ValidationArguments {
  value: any;
  constraints?: any[];
  targetName?: string;
  object: any;
  property: string;
}

// registerDecorator function (used to register custom validators)
export function registerDecorator(options: {
  target: Function;
  propertyName: string;
  options?: ValidationOptions;
  constraints?: any[];
  validator: Function | ValidatorConstraintInterface;
}): void {
  // No-op in frontend
}

// Utility functions (not decorators)
export const isArray = (value: any): value is any[] => Array.isArray(value);
